module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "Nik_Headshot 2024005.516b9d8d.jpg";